import axios from 'axios'

export default {
    methods: {
        openEmployeeModal (employee_id, tab = null) {
            this.modal_employee_id = employee_id
            this.modal_tab = tab
        },

        bulkDisableAccounts () {

            if ( confirm("Vill du verkligen inaktivera "+this.bulk_selected.length+" konton?")){
                if ( confirm("Vänligen bekräfta igen.")){

                    axios.post(
                        '/employees/bulkDisableAccounts',
                        { employee_ids: this.bulk_selected }
                    ).then(result => {
                        bus.$emit(
                            'notify',
                            this.bulk_selected.length + ' konton har blivit inaktiverade'
                        )
                        this.refresh()
                        this.bulk_selected = []
                    })

                }
            }

        },
        bulkDeleteAccounts () {

            if ( confirm("Vill du verkligen ta bort "+this.bulk_selected.length+" konton? Det kan inte ångras.")){
                if ( confirm("Vänligen bekräfta igen.")){

                    axios.post(
                        '/employees/bulkDeleteAccounts',
                        { employee_ids: this.bulk_selected }
                    ).then(result => {
                        bus.$emit(
                            'notify',
                            this.bulk_selected.length + ' konton har blivit raderade'
                        )
                        this.refresh()
                        this.bulk_selected = []
                    })
                }
            }

        },
        bulkInviteAccounts () {

            if ( confirm("Vill du verkligen bjuda in "+this.bulk_selected.length+" konton?")){
                if ( confirm("Vänligen bekräfta igen.")){
                    axios.post(
                        '/employees/bulkInviteAccounts',
                        { employee_ids: this.bulk_selected }
                    ).then(result => {
                        bus.$emit(
                            'notify',
                            this.bulk_selected.length + ' har blivit inbjudna'
                        )
                        this.refresh()
                        this.bulk_selected = []
                    })

                }
            }
        }
    }
}
